module.exports = __webpack_public_path__ + "static/media/RiverOfRoses.707edfd8.jpg";